import { FormGroup } from '@angular/forms';

export function focusFirstInvalid(form: FormGroup, root: HTMLElement): void {
  if (!form || !root) {
    return;
  }

  form.markAllAsTouched();

  // Defer to allow validation classes and errors to render
  requestAnimationFrame(() => {
    const focusables = Array.from(
      root.querySelectorAll<HTMLElement>(
        [
          'input',
          'select',
          'textarea',
          'button',
          '[contenteditable="true"]',
          '[role="combobox"]',
          '.p-inputtext',
          '.p-dropdown',
          '.p-multiselect',
        ].join(', '),
      ),
    );

    const invalid = focusables.find((el) => {
      const disabled =
        el.hasAttribute('disabled') ||
        el.getAttribute('aria-disabled') === 'true';
      if (disabled) {
        return false;
      }

      const selfInvalid =
        el.classList.contains('ng-invalid') ||
        el.getAttribute('aria-invalid') === 'true';

      if (selfInvalid) {
        return true;
      }

      const ancestorInvalid = el.closest('.ng-invalid');
      if (
        ancestorInvalid &&
        ancestorInvalid !== root &&
        ancestorInvalid.tagName !== 'FORM'
      ) {
        return true;
      }

      return false;
    });

    if (invalid && typeof invalid.focus === 'function') {
      invalid.focus({ preventScroll: true });
    }
  });
}
